import { RadioOption } from 'components/ui/radio-group'

export const ONBOARDING_COMFORT_LEVEL_OPTIONS: RadioOption[] = [
  {
    id: 1,
    title: 'onboarding_questionnaire_selection_novice',
    description: 'onboarding_questionnaire_selection_novice_subheading',
    value: 'Novice',
  },
  {
    id: 2,
    title: 'beginner',
    description: 'onboarding_questionnaire_selection_beginner_subheading',
    value: 'Beginner',
  },
  {
    id: 3,
    title: 'intermediate',
    description: 'onboarding_questionnaire_selection_intermediate_subheading',
    value: 'Intermediate',
  },
  {
    id: 4,
    title: 'onboarding_questionnaire_selection_advanced',
    description: 'onboarding_questionnaire_selection_advanced_subheading',
    value: 'Advanced',
  },
  {
    id: 5,
    title: 'onboarding_questionnaire_selection_expert',
    description: 'onboarding_questionnaire_selection_expert_subheading',
    value: 'Expert',
  },
]
